import { useParams } from "react-router-dom";
import { HOME_ROUTE, TEAM_ROUTE, TEAMS_ROUTE } from "../../app/router/routes";
import { useAppSelector } from "../../app/store/store";
import { FEATURES, FEATURE_SECTIONS, hasFeature } from "../../entities/my";
import { LayoutPages } from "../layoutPages";
import { TeamCardWidget, TeamsWidget } from "../../widgets/teams";
import { AccessDeniedRedirect } from "../../shared/ui/accessDeniedRedirect";

export default function TeamsPage() {
    const {id} = useParams<{id: string}>()
    const {my} = useAppSelector(s => s.myReducer)
    const isAccess = hasFeature(my, FEATURE_SECTIONS.TEAMS)
        && (hasFeature(my, FEATURES.TEAMS.READ) || hasFeature(my, FEATURES.TEAMS.MANAGE))

    if(!isAccess){
        return <AccessDeniedRedirect to={HOME_ROUTE.path} />
    }

    return (
        <LayoutPages title={id ? TEAM_ROUTE.name : TEAMS_ROUTE.name} titleLink={id ? TEAMS_ROUTE.path : undefined}>
            {id ? <TeamCardWidget /> : <TeamsWidget />}
        </LayoutPages>
    )
}
